import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Service from "../Services/Service";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Switch,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

let vUserMapID = 0;

const RoleMapping = () => {
  const [loading, setLoading] = useState(false);
  const [roleMapping, setRoleMapping] = useState([]);
  const [optionsGrp, setOptionsGroup] = useState([]);
  const [optionsPrntMnu, setParentMenus] = useState([]);
  const [editing, setEditing] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedMenu, setSelectedMenu] = useState(null); //  single selected menu
  //new
  // Dashboard Div Access
  const [dashboardDivs, setDashboardDivs] = useState([]);
  const [dashboardLoading, setDashboardLoading] = useState(false);
  // Store dashboard permissions separately for each menu
  const [dashboardAccessByMenu, setDashboardAccessByMenu] = useState({});

  useEffect(() => {
    Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/RoleMapping");
    //Service.setApiUrl("https://localhost:7106/api/RoleMapping");
    bindGroup();
  }, []);

  const navigate = useNavigate();

  const bindGroup = async () => {
    try {
      const res = await Service.loadUserGroup(0, "Group");
      setOptionsGroup(res.data);
    } catch (err) {
      console.error("Error loading groups:", err);
    }
  };

  const bindMenus = async (groupId) => {
    try {
      const res = await Service.loadMenuDtls("Get", groupId);
      console.log("TABLE", res.data.table);
      console.log("TABLE1", res.data.table1);

      setParentMenus(res.data.table || []);
      setRoleMapping(res.data.table1 || []);

      setSelectedMenu(null);
    } catch (err) {
      console.error("Error loading menus:", err);
    }
  };

  //new
  const bindDashboardDivs = async (groupId, menuId) => {
    try {
      setDashboardLoading(true);

      const res = await Service.getDashboardDivAccess(groupId, menuId);

      const data = res.data || [];

      console.log("Dashboard Div Access:", data);

      // Show current menu's divs
      setDashboardDivs(data);

      // Store this menu's divs separately
      setDashboardAccessByMenu((prev) => ({
        ...prev,
        [menuId]: data,
      }));
    } catch (err) {
      console.error("Error loading dashboard div access:", err);

      setDashboardDivs([]);
    } finally {
      setDashboardLoading(false);
    }
  };

  // const dashboardTemplates =
  //    (res.data.table1 || []).filter(
  //       x =>
  //          x.groupCode === dashboardMenu?.mnuId &&
  //          x.parentGroupCode === dashboardMenu?.mnuId
  //    );

  // setParentMenus(dashboardTemplates);

  // //setParentMenus(dashboardTemplates);
  //       setSelectedMenu(null); // reset selection when group changes
  //       //console.log(res.data.table1);
  //       //console.log(res.data.table);
  //     } catch (err) {
  //       console.error("Error loading menus:", err);
  //     }
  //   };

  const clear = () => {
    vUserMapID = 0;
    setSelectedGroup("");
    setEditing(false);
    setRoleMapping([]);
    setParentMenus([]);
    setSelectedMenu(null);

    //new
    // Dashboard Div Access
    setDashboardDivs([]);
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   try {
  //     const payload = {
  //       groupId: selectedGroup?.groupId || 0, // from dropdown
  //       groupName: selectedGroup?.groupName || "", // from dropdown
  //       opFlag: "Insert", // hardcoded
  //       listUserRoleMapping: [],
  //     };

  //     // build listUserRoleMapping
  //     // optionsPrntMnu.forEach((main) => {
  //     //   const children = roleMapping.filter((m) => m.groupCode === main.mnuId);

  //     //   children.forEach((child) => {
  //     //     payload.listUserRoleMapping.push({
  //     //       mainMenuId: main.mnuId,
  //     //       menuId: child.mnuId,
  //     //       editAccess: child.editAccess,
  //     //       deleteAccess: child.deleteAccess,
  //     //       visible: child.visible,
  //     //     });
  //     //   });
  //     // });

  //     roleMapping.forEach((child) => {
  //       console.log(child.data);
  //       payload.listUserRoleMapping.push({
  //         mainMenuId: child.parentGroupCode || child.groupCode || 0,
  //         menuId: child.mnuId,
  //         editAccess: child.editAccess,
  //         deleteAccess: child.deleteAccess,
  //         visible: child.visible,
  //       });
  //     });

  //     console.log("Final Payload:", payload);

  //     // ✅ API Call
  //     const res = await Service.create(payload);
  //     console.log(res);

  //     if (res.data.success) {
  //       alert("Menu Access saved successfully!");
  //       clear();
  //     } else {
  //       alert("Failed to save menu access!");
  //     }
  //   } catch (error) {
  //     console.error("Error saving menu access:", error);
  //     alert("An error occurred while saving.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  //new

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // =====================================================
      // VENDOR DASHBOARD DIV ACCESS
      // =====================================================

      // =====================================================
      // SAVE ALL DASHBOARD MENU ACCESS
      // =====================================================

      if (Object.keys(dashboardAccessByMenu).length > 0) {
        const groupID = selectedGroup?.groupId || 0;

        // Save every dashboard menu
        for (const [menuID, dashboardAccess] of Object.entries(
          dashboardAccessByMenu,
        )) {
          const payload = {
            groupID: groupID,

            menuID: Number(menuID),

            dashboardAccess: dashboardAccess.map((div) => ({
              divID: div.divID,
              accessID: div.accessID,
              accessValue: Boolean(div.accessValue),
            })),
          };

          console.log("Saving Dashboard Menu:", menuID);

          console.log("Dashboard Payload:", payload);

          await Service.saveDashboardDivAccess(payload);
        }

        alert("Dashboard access saved successfully!");

        // Reload currently selected menu
        if (selectedMenu) {
          await bindDashboardDivs(groupID, selectedMenu);
        }

        return;
      }

      // =====================================================
      // EXISTING ESSP MENU ACCESS
      // =====================================================

      const payload = {
        groupId: selectedGroup?.groupId || 0,
        groupName: selectedGroup?.groupName || "",
        opFlag: "Insert",
        listUserRoleMapping: [],
      };

      roleMapping.forEach((child) => {
        payload.listUserRoleMapping.push({
          mainMenuId: child.parentGroupCode || child.groupCode || 0,

          menuId: child.mnuId,

          editAccess: child.editAccess,

          deleteAccess: child.deleteAccess,

          visible: child.visible,
        });
      });

      console.log("Final Payload:", payload);

      const res = await Service.create(payload);

      console.log(res);

      if (res.data.success) {
        alert("Menu Access saved successfully!");

        clear();
      } else {
        alert("Failed to save menu access!");
      }
    } catch (error) {
      console.error("Error saving access:", error);

      alert("An error occurred while saving.");
    } finally {
      setLoading(false);
    }
  };

  // const handleMenuClick = (id) => {
  //   debugger;
  //   setSelectedMenu(id);
  // };

  //new

  const handleMenuClick = async (id) => {
    setSelectedMenu(id);

    // If this menu was already loaded,
    // show the unsaved changes from React state.
    if (dashboardAccessByMenu[id]) {
      setDashboardDivs(dashboardAccessByMenu[id]);

      return;
    }

    // Otherwise load from database
    setDashboardDivs([]);

    if (selectedGroup?.groupId) {
      await bindDashboardDivs(selectedGroup.groupId, id);
    }
  };
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        paddingLeft: 50,
        paddingRight: 50,
      }}
    >
      <Box>
        <Button
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/DashboardFinal")}
        >
          Back to Home
        </Button>
      </Box>

      <Box
        sx={{
          mt: 2,
          bgcolor: "background.paper", // white/light background
          borderRadius: 3, // rounded corners
          boxShadow: 6, // floating shadow
          p: 4, // inner padding
          border: "1px solid rgba(0,0,0,0.12)",
        }}
      >
        <form onSubmit={handleSubmit}>
          {/* Group Dropdown */}
          <FormControl fullWidth sx={{ maxWidth: 300, mb: 3 }}>
            <InputLabel id="ddlGroupName-label">Group Name</InputLabel>
            <Select
              labelId="ddlGroupName-label"
              value={selectedGroup?.groupId || ""}
              onChange={(e) => {
                const grp = optionsGrp.find(
                  (g) => g.groupId === e.target.value,
                );
                setSelectedGroup(grp); // store full object

                //new
                // Reset dashboard div access when group changes
                setDashboardDivs([]);
                // Clear dashboard selections
                // because group has changed
                setDashboardAccessByMenu({});
                bindMenus(grp.groupId); // pass only id to bindMenus
              }}
            >
              {optionsGrp.map((grp) => (
                <MenuItem key={grp.groupId} value={grp.groupId}>
                  {grp.groupName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Row with Left (Menu) and Right (Details/Table) */}
          <Grid container spacing={2}>
            {/* Left Column: Menu List */}
            <Grid item xs={12} md={5} sx={{ minWidth: 300 }}>
              <Typography variant="subtitle1">Main Menu</Typography>
              <Paper
                variant="outlined"
                sx={{
                  maxHeight: 350,
                  overflowY: "auto",
                  mt: 1,
                  minWidth: 280,
                  minHeight: 100,
                }}
              >
                <List>
                  {optionsPrntMnu.map((menu) => (
                    <ListItemButton
                      key={menu.mnuId}
                      selected={selectedMenu === menu.mnuId}
                      onClick={() => handleMenuClick(menu.mnuId)}
                    >
                      <ListItemText primary={menu.menuText} />
                      <ListItemIcon sx={{ minWidth: 30 }}>
                        <ArrowForwardIosIcon
                          fontSize="small"
                          color={
                            selectedMenu === menu.mnuId ? "primary" : "disabled"
                          }
                        />
                      </ListItemIcon>
                    </ListItemButton>
                  ))}
                </List>
              </Paper>
            </Grid>

            {/* Right Column: Role Mapping / Details */}
            <Grid item xs={12} md={8} sx={{ minWidth: 600, minHeight: 100 }}>
              <Typography
                variant="subtitle1"
                sx={{ mb: 1, fontWeight: "bold" }}
              >
                Menu Access
              </Typography>
              <Paper
                variant="outlined"
                sx={{ minWidth: 580, minHeight: 100, p: 2 }}
              >
                {selectedMenu ? (
                  <>
                    <Typography>
                      Showing access details for{" "}
                      <strong>
                        {
                          optionsPrntMnu.find((m) => m.mnuId === selectedMenu)
                            ?.menuText
                        }
                      </strong>
                    </Typography>

                    {dashboardDivs.length > 0 ? (
                      // =====================================================
                      // VENDOR DASHBOARD DIV ACCESS
                      // =====================================================

                      <>
                        <Typography
                          sx={{
                            mb: 2,
                            fontWeight: "bold",
                          }}
                        >
                          Dashboard Access
                        </Typography>

                        {dashboardLoading ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              p: 3,
                            }}
                          >
                            <CircularProgress />
                          </Box>
                        ) : (
                          <TableContainer sx={{ minWidth: 500 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Dashboard Div</TableCell>

                                  <TableCell>Div Key</TableCell>

                                  <TableCell align="center">View</TableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {dashboardDivs.map((div) => (
                                  <TableRow key={div.divID}>
                                    <TableCell>{div.divName}</TableCell>

                                    <TableCell>{div.divKey}</TableCell>

                                    <TableCell align="center">
                                      <Switch
                                        checked={Boolean(div.accessValue)}
                                        onChange={(e) => {
                                          const checked = e.target.checked;

                                          setDashboardDivs((prev) => {
                                            const updated = prev.map((item) =>
                                              item.divID === div.divID &&
                                              item.accessID === div.accessID
                                                ? {
                                                    ...item,
                                                    accessValue: checked,
                                                  }
                                                : item,
                                            );

                                            // Store the updated permissions
                                            // against the currently selected menu
                                            setDashboardAccessByMenu(
                                              (menuPrev) => ({
                                                ...menuPrev,
                                                [selectedMenu]: updated,
                                              }),
                                            );

                                            return updated;
                                          });
                                        }}
                                      />
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}
                      </>
                    ) : (
                      // =====================================================
                      // EXISTING ESSP MENU ACCESS
                      // =====================================================

                      <TableContainer sx={{ minWidth: 500 }}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>Menu</TableCell>

                              <TableCell align="center">Edit Access</TableCell>

                              <TableCell align="center">
                                Delete Access
                              </TableCell>

                              <TableCell align="center">Visible</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {roleMapping
                              .filter((r) => r.groupCode === selectedMenu)
                              .map((roleMap) => (
                                <TableRow key={roleMap.mnuId}>
                                  <TableCell>{roleMap.menuText}</TableCell>

                                  {/* Edit Access */}
                                  <TableCell align="center">
                                    <Switch
                                      checked={roleMap.editAccess}
                                      onChange={(e) => {
                                        const updated = roleMapping.map((r) =>
                                          r.mnuId === roleMap.mnuId
                                            ? {
                                                ...r,
                                                editAccess: e.target.checked,
                                              }
                                            : r,
                                        );

                                        setRoleMapping(updated);
                                      }}
                                    />
                                  </TableCell>

                                  {/* Delete Access */}
                                  <TableCell align="center">
                                    <Switch
                                      checked={roleMap.deleteAccess}
                                      onChange={(e) => {
                                        const updated = roleMapping.map((r) =>
                                          r.mnuId === roleMap.mnuId
                                            ? {
                                                ...r,
                                                deleteAccess: e.target.checked,
                                              }
                                            : r,
                                        );

                                        setRoleMapping(updated);
                                      }}
                                    />
                                  </TableCell>

                                  {/* Visible */}
                                  <TableCell align="center">
                                    <Switch
                                      checked={roleMap.visible}
                                      onChange={(e) => {
                                        const updated = roleMapping.map((r) =>
                                          r.mnuId === roleMap.mnuId
                                            ? {
                                                ...r,
                                                visible: e.target.checked,
                                              }
                                            : r,
                                        );

                                        setRoleMapping(updated);
                                      }}
                                    />
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </>
                ) : (
                  <Typography color="text.secondary">
                    Please select a menu from the left
                  </Typography>
                )}
              </Paper>
            </Grid>
          </Grid>

          {/* Submit Button */}
          <Box mt={3}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
              startIcon={loading && <CircularProgress size={20} />}
            >
              {loading ? "Saving..." : "Save"}
            </Button>
          </Box>
        </form>
      </Box>
    </div>
  );
};

export default RoleMapping;
